import { z } from "zod";
import { env } from "../../env";
import {
  parseServiceInput,
  requestConfig,
  throwFromFailedResponse,
} from "../../globals";

export const deleteWishlistItemProps = z
  .object({
    token: z.string(),
    itemId: z.number(),
  })
  .extend(requestConfig.shape);

export type DeleteWishlistItemProps = z.infer<typeof deleteWishlistItemProps>;

export const deleteWishlistItem = async (
  args: DeleteWishlistItemProps,
): Promise<void> => {
  const {
    endpoint = env.ACCOUNT_SERVICE_URL,
    token,
    itemId,
    proxyAuthSecret,
  } = parseServiceInput(deleteWishlistItemProps, args);

  const headers = new Headers({
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
    ...(proxyAuthSecret && { "X-NG-Proxy-Auth": proxyAuthSecret }),
  });

  const response = await fetch(`${endpoint}/v1/wishlist/${itemId}`, {
    method: "DELETE",
    headers,
  });

  if (!response.ok) {
    await throwFromFailedResponse(response);
  }

  return;
};
